export default theme => ({
  page_header_bar_static: {
    display: "flex",
  },
  page_header_bar_title_container: {
    textAlign: "center",
    margin: "auto",
  },
  page_header_bar_main_title_container: {
    display: "flex",
    alignItems: "center",
  },
  page_header_bar_title: {
    fontSize: "1.5rem",
    margin: "auto",
  },
  page_header_bar_main_title: {
    paddingLeft: theme.spacing(3),
    marginBottom: 0,
  },
});
